/* eslint-disable require-jsdoc */
// eslint-disable-next-line max-len
const pApiKey =
  // eslint-disable-next-line max-len
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJzYW1wbGUtYXV0aC1zZXJ2ZXIiLCJjbGllbnRfaWQiOjEwLCJ0b2tlbl9pZCI6OCwiZXhwIjoxNjE3OTgwNTgyLjY0ODg5OTN9.lTRQVrIf_DEbxtYNz5H8CEQe-hGrCKTwY4o4o_3nOqm8HDKZlTjR-6u25XfaQMi1CKONjTZFGgog37uSLr4inLZv4Yw-w99ymh4oCINGUNoXjV6SHDiM1SYcg7eHKXvZSgm9ojev4cVW-wmWuxefXlr1qWPzSevwjPS62mJ52n9kckT8WelqoCpr7aX4--1izoV24rNpMrrK6mJ6w_EXxYicWWItBTtGrrex0onuRwZkxybv0bD2BeTmpeukpW2zJA68Wpnz6rjdI4sQWBfdIdtF3PWsWNAJDHcsadFzOY5PBjIGLTVTpAGy5Z075tAbIMuUvZLKghsZZVnvO86H8Um5-6c-OnROPWBD8f8-Kd8MILIfxrrLz2FRhYJGYkVyeTf8yWN_G5MYM0REaq_M4AYJ-xfH9oMFsoxX-BhoOwpV9mrFDifApAi_XJGRwSceQd5C30Of9pNDT-H_QQCeo2T9o-ZN1mjEkwdbtmTvuJo5jUr8rM3V2MbY1o_BI8U2gShTu1FR1bY1qR3AfPva8QifEwQjFPShnEULXOec5LP0UJiur5wlzfYDqMQF90-fPy4W9zRdqnbhy_gw4416lwHzHOqZRWg0uyjgKCTxWyPqnvFEssQXJubihNulybI7Jw61NPgDnIi3JTMiAuGZWzvwVj6jdZIBV1f7yvvTMsA';
const useFetch = false;
const debug = false;
const subscriber = '';
// const hearbyTheme = 'light';
// https://partner.a4api.net/v1
const localHost = 'http://localhost:8000/v1';
const a4backendBase = 'https://a4backend.net:8000';
const pApiDevBase = 'https://dev.a4api.net/v1';
const pApiPartnerBase = 'https://partner.a4api.net/v1';
const londonLb = 'https://a4backend-test-eu-west-2-504944017.eu-west-2.elb.amazonaws.com';
const tempECSBase = 'https://partners.a4api.net'
const pApiBase = pApiDevBase; //pApiPartnerBase doesnt reset markers
const localEnv = false;
const isHearby = true;

const geoApiKey = 'ge-c5ca7884ca66fdc2';
export {pApiKey, useFetch, debug, a4backendBase, pApiDevBase, pApiBase, localEnv, isHearby, geoApiKey, subscriber };
